import { isBrowser } from "./browser";

export const GORGIAS_ELEMENT_IDS = [
  "chat-button",
  "mount-floating-engagement-widget",
  "gorgias-chat-container",
];

// Gorgias loads lazily
// In order to correctly hide the chat, we need to apply visibility changes once it's loaded
let isChatVisible = true;
let observer;

function applyVisibility() {
  const display = isChatVisible ? "flex" : "none";
  let allFound = true;

  GORGIAS_ELEMENT_IDS.forEach((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.style.display = display;
    } else {
      allFound = false;
    }
  });

  if (allFound && observer) {
    observer.disconnect();
    observer = null;
  }
}

function ensureObserver() {
  if (!isBrowser || observer || !document.body) {
    return;
  }

  observer = new MutationObserver(applyVisibility);
  observer.observe(document.body, { childList: true, subtree: true });
}

export function setGorgiasChatVisibility(visible) {
  if (!isBrowser) {
    return;
  }
  isChatVisible = visible;
  applyVisibility();
  ensureObserver();
}
